import {ListItemText, MenuItem, Paper, PaperProps, useTheme} from '@mui/material';

export function NomenclatureGroupEditPaper({onManageGroups, ...props}: PaperProps & {onManageGroups: () => void}) {
    const theme = useTheme();
    return (
        <Paper {...props}>
            {props.children}
            <MenuItem
                onMouseDown={e => e.preventDefault()}
                onClick={onManageGroups}
                style={{
                    borderTop: '1px solid #eee',
                    color: theme.palette.primary.main,
                    fontWeight: 500,
                }}
            >
                <ListItemText primary="Редактирование групп" />
            </MenuItem>
        </Paper>
    );
}
